module.exports = __webpack_public_path__ + "img/tiffany-and-co-cent.d91b5581.jpg";